import { SettingService } from 'features/userSettings';
import { AccountStatus } from 'entities/account';

export const getDefaultAccountStatus = () => {
  return SettingService.getLocalSetting<AccountStatus>('selectedAccountTab', 'sessionStorage') ?? 'ACTIVE';
};
